import React from 'react';
import { Box } from '@mui/material';
import { spaces } from '../../../../assets/styles/themes/tokens';
import useScreenSize from '../../../../utils/useScreenSize';
import useCardDimensions from '../../../../utils/useCardDimensions';

const SearchResultsContainer: React.FC = (props) => {
  const { isSmallScreen } = useScreenSize();
  const cardDimensions = useCardDimensions();
  
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: isSmallScreen ? spaces.sm : spaces.md,
    maxWidth: cardDimensions.desktop.maxWidth,
    marginX: 'auto',
  }}>
    { props.children }
  </Box>;
};

export default SearchResultsContainer;
